import some from 'lodash/some';
import UserRole from "./roles";

export const userHasRole = (roles, roleName) => some(roles, ['roleName', roleName]);

export const getHighestRole = (roles) => {
    if (userHasRole(roles, UserRole.Admin)) {
        return 'RoofSnap Admin';
    }

    if (userHasRole(roles, UserRole.SketchOsAdmin)) {
        return 'Sketch OS Admin';
    }

    if (userHasRole(roles, UserRole.SketchTech)) {
        return 'Sketch Tech';
    }

    if (userHasRole(roles, UserRole.AccountAdmin)) {
        return 'Account Admin';
    }

    if (userHasRole(roles, UserRole.SalesAppOnly)) {
        return 'Sales-App Only';
    }

    return 'User does not have position';
};
